import React from 'react';
import '../styles/research.css';

export default function Research() {
  return (
    <section id="research" className="research-section">
      <h2 className="section-title">My <span>Research</span></h2>

      <div className="research-outer-border">
        <div className="research-grid">
          <div className="research-card">
            <div className="research-card-image">
              <img src="/assets/Research.jpg" alt="Research Certificate" />
            </div>

            <div className="research-card-content">
              <h3 className="research-topic">
                AI-Powered Detection of Cyber Attacks: Addressing Deepfakes and Identity Theft
              </h3>
              <p className="research-summary">
                This research proposes a multi-modal AI framework to detect and prevent cyber threats involving deepfakes and identity fraud.
                The project utilizes CNNs, Capsule Networks, and Ensemble Learning models to analyze visual, audio, and behavioral data.
                It achieves real-time detection accuracy and has been successfully published in a Scopus-indexed journal.
              </p>
              <ul className="research-bullets">
                <li> 97% accuracy in image deepfake detection using CapsuleNet + ELA</li>
                <li> 98.5% audio stream classification using spectral + Random Forest</li>
                <li> Ensemble of CNN + KNN + SVM improves identity theft detection</li>
                <li> Real-time processing with 0.6-second inference time</li>
                <li> Published in IJRASET (Vol. 13, Issue VI, June 2025)</li>
              </ul>
              <div className="research-links">
  <a
    className="research-link"
    href="https://doi.org/10.22214/ijraset.2025.72416"
    target="_blank"
    rel="noopener noreferrer"
  >
    📄 View Published Paper
  </a>
  <a
    className="research-link"
    href="https://www.researchgate.net/publication/393167494_AI-Powered_Detection_of_Cyber_Attacks_Addressing_Deepfakes_and_Identity_Theft"
    target="_blank"
    rel="noopener noreferrer"
  >
    🔗 View Contribution
  </a>
</div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
